import { useCallback, useEffect, useRef, useState } from 'react';
import type { MessageTemplate } from '../../../../lib/shared/types';
import { messageTemplateApi } from '../../lib/api';
import { validMessageTemplate } from './messageText';

export function useMessageTemplate() {
  const [template, setTemplate] = useState<MessageTemplate | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [revision, setRevision] = useState(0);
  const epoch = useRef(0);
  useEffect(() => {
    const version = ++epoch.current;
    setLoading(true);
    setError(false);
    void messageTemplateApi
      .get()
      .then(result => {
        if (version !== epoch.current) return;
        if (
          result.error ||
          !result.data ||
          (result.data.template !== null && !validMessageTemplate(result.data.template))
        ) {
          setError(true);
        } else setTemplate(result.data.template);
      })
      .catch(() => {
        if (version === epoch.current) setError(true);
      })
      .finally(() => {
        if (version === epoch.current) setLoading(false);
      });
    return () => {
      epoch.current = version + 1;
    };
  }, [revision]);
  const save = useCallback(async (value: MessageTemplate): Promise<boolean> => {
    const version = epoch.current;
    try {
      const result = await messageTemplateApi.save(value);
      if (
        version !== epoch.current ||
        result.error ||
        !result.data?.template ||
        !validMessageTemplate(result.data.template)
      )
        return false;
      setTemplate(result.data.template);
      return true;
    } catch {
      return false;
    }
  }, []);
  return { template, loading, error, save, retry: () => setRevision(value => value + 1) };
}
